import React, { useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer, { rootSaga } from './modules';
import { setToken, setUser, setAccount, setPlan } from './modules/auth';
import { getContainerAsync, getContentsAsync, getEmailAsync, getFilesizeAsync, requestSave, selectContent, setEmailId, showSidebar, finishLoaidngPreview, initSidebar, historySave } from './modules/editor';

import postMsg from './lib/postMsg';

import { RootState } from './modules';

import EditorContainer from './containers/EditorContainer';
import LoginContainer from './containers/LoginContainer';

import './assets/css/index.scss';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  // applyMiddleware(sagaMiddleware),
  composeWithDevTools(
    applyMiddleware(sagaMiddleware)
  )
);

sagaMiddleware.run(rootSaga);

type MatchParams = {
	emailId: string
};

function App() {
  const dispatch = useDispatch();
  const { contents } = useSelector((state: RootState) => state.editor);
  const emailId = useSelector((state: RootState) => state.editor.emailId);
  const isLoading = useSelector((state: RootState) => state.auth.account.id === '' || Object.keys(state.auth.plan).length === 0 || state.editor.email.id == -1 || (state.editor.email.subType === 4 && state.editor.testGroup == null));

  const onMesssage = (emailId)=> function (e) {
    const { data, msg } = e.data;
    switch (msg) {
      case 'token':
        dispatch(setToken(data));
        break;
      case 'emailId':
        dispatch(setEmailId(data));
        break;
      case 'userInfo':
        dispatch(setUser(JSON.parse(data)));
        break;
      case 'accountInfo':          
        dispatch(setAccount(JSON.parse(data)));
        break;
      case 'planInfo':      
        dispatch(setPlan(JSON.parse(data)));
        break;
      case 'requestSave':
        dispatch(requestSave(data));
        break;
      case 'requestHistorySave':
        dispatch(historySave());
        break;
      case 'loadContent':
        console.log("### loadContent", emailId);
        loadContents(emailId);
        break;
      case 'unselectContent':          
        dispatch(selectContent(-1));
        break;
      case 'openSidebar':
        dispatch(showSidebar());
        break;
      case 'finishLoaidngPreview':
        dispatch(finishLoaidngPreview());
        break;
      default:
        break;
    }
  }

  useEffect(()=>{
    postMsg.send('boot');
    dispatch(initSidebar());
  },[]);

  useEffect(() => {
    console.log("### addEventListener", emailId);
    let handleFunction = onMesssage(emailId);
    window.addEventListener('message', handleFunction);
    return ()=>{
      console.log("#### remove function");
      window.removeEventListener('message', handleFunction);
    }
  }, [emailId]);

  useEffect(() => {
    if (contents?.length === 0 || isLoading) {
      return;
    }
    postMsg.send('contentsReady', contents?.length !== 0);
  }, [contents, isLoading])

  const loadContents = (emailId) => {
    dispatch(getEmailAsync.request(emailId));
		dispatch(getContentsAsync.request(emailId));
		dispatch(getContainerAsync.request(emailId));
		dispatch(getFilesizeAsync.request(emailId));
  }

  if (isLoading) return <></>;
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/editor/:emailId" component={EditorContainer} />
        <Route exact path="/" component={LoginContainer} />
      </Switch>
    </BrowserRouter>
  );
}


const AppWrapper = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

export default AppWrapper;
